import { animate, inView, scroll, stagger } from 'motion';
import simpleParallax from 'simple-parallax-js/src/vanilla';

const htmlElement = document.querySelector('html');
const body = document.querySelector('body');
const header = document.querySelector('.header');
const sideCart = document.querySelector('.side-cart');

if (!htmlElement.classList.contains('shopify-design-mode')) {
  inView('.in-view', ({ target }) => {
    animate(target, { opacity: 1 });

    if (target.querySelector('.slide-up')) {
      animate(
        target.querySelectorAll('.slide-up'),
        { opacity: 1, transform: 'none' },
        { delay: 0, duration: target.dataset.duration ? target.dataset.duration : 0.9, easing: [0.17, 0.55, 0.55, 1] }
      );
    }

    if (target.querySelector('.slide-stagger')) {
      animate(
        target.querySelectorAll('.slide-stagger'),
        { opacity: 1, transform: 'none' },
        {
          delay: stagger(0.3),
          duration: target.dataset.duration ? target.dataset.duration : 0.9,
          easing: [0.17, 0.55, 0.55, 1],
        }
      );
    }
    if (target.querySelector('.slide-stagger-left')) {
      animate(
        target.querySelectorAll('.slide-stagger-left'),
        { opacity: 1, transform: 'none' },
        {
          delay: stagger(0.3),
          duration: target.dataset.duration ? target.dataset.duration : 0.9,
          easing: [0.17, 0.55, 0.55, 1],
        }
      );
    }

    if (target.querySelector('.slide-in')) {
      animate(
        target.querySelectorAll('.slide-in'),
        { opacity: 1, transform: 'none' },
        { delay: 0, duration: target.dataset.duration ? target.dataset.duration : 0.9, easing: [0.17, 0.55, 0.55, 1] }
      );
    }

    if (target.querySelector('.slide-in-left')) {
      animate(
        target.querySelectorAll('.slide-in-left'),
        { opacity: 1, transform: 'none' },
        { delay: 0, duration: target.dataset.duration ? target.dataset.duration : 0.9, easing: [0.17, 0.55, 0.55, 1] }
      );
    }

    if (target.querySelector('.fade-in')) {
      animate(
        target.querySelectorAll('.fade-in'),
        { opacity: 1 },
        { delay: 0, duration: target.dataset.duration ? target.dataset.duration : 0.9, easing: [0.17, 0.55, 0.55, 1] }
      );
    }
    if (target.querySelector('.fade-in-delay')) {
      animate(
        target.querySelectorAll('.fade-in-delay'),
        { opacity: 1 },
        { delay: 0.5, duration: target.dataset.duration ? target.dataset.duration : 0.9, easing: [0.17, 0.55, 0.55, 1] }
      );
    }
  });
} else {
  htmlElement.classList.add('no-anim');
}

if (window.innerWidth > 1024) {
  scroll(animate(header, { y: [-50] }), {
    target: body,
    offset: ['start', '50px'],
  });
} else {
  scroll(animate(header, { y: [-50] }), {
    target: body,
    offset: ['start', '200px'],
  });
}
if (window.innerWidth < 1024) {
  scroll(animate(sideCart, { top: ['82px'] }), {
    target: body,
    offset: ['start', '200px'],
  });
}
if (window.innerWidth < 540) {
  scroll(animate(sideCart, { top: ['70px'] }), {
    target: body,
    offset: ['start', '200px'],
  });
}
function initiateParallax() {
  if (window.innerWidth > 1024) {
    const parallaxNodes = document.querySelectorAll('.parallax-wrapper');
    if (parallaxNodes.length) {
      let options = {
        overflow: true,
        scale: 1.2,
        orientation: 'up',
      };

      var instance = new simpleParallax(parallaxNodes, options);
      instance.refresh();
    }
  }
}

document.addEventListener('DOMContentLoaded', initiateParallax);
